export const general = {
  displayDate: 'DD/MM/YYYY',
  displayDateTime: 'DD-MM-YYYY HH:mm',
  displayTime: 'HH:mm',
  displayTime12: 'hh:mm A',
};

export const eventTypes = {
  tournament: 'Torneo',
  single_event: 'Evento Único',
};

export const matchStatuses = {
  WITHOUT_PROGRAM: 'without_program',
  PROGRAMED: 'programed',
  REPROGRAMED: 'reprogramed',
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'in_progress',
  FINISHED: 'finished',
};
